module.exports = __webpack_public_path__ + "static/media/s4.0745e972.jpg";